import React from "react";
import { liveAlerts } from "../mock";

const Ticker = () => {
  const items = [...liveAlerts, ...liveAlerts];
  return (
    <div className="relative border-y border-[#1c2533] bg-[#0a0e14] overflow-hidden">
      <div className="marquee-track py-2.5">
        {items.map((a, i) => {
          const sevClass =
            a.sev === "HIGH" ? "sev-high" : a.sev === "MED" ? "sev-med" : "sev-low";
          return (
            <div
              key={i}
              className="flex items-center gap-3 px-6 font-mono text-[11px] tracking-[0.08em] whitespace-nowrap"
            >
              <span className={`${sevClass} pulse-dot`}>●</span>
              <span className={`${sevClass} font-semibold`}>{a.sev}</span>
              <span className="text-slate-300">{a.text}</span>
              <span className="text-slate-500">—</span>
              <span className="text-slate-400">{a.src}</span>
              <span className="text-slate-500">—</span>
              <span className="text-cyan-400">{a.status}</span>
              <span className="text-slate-700 mx-3">//</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Ticker;
